export default "__VITE_ASSET__WVZwiTWjGNB6TDlJjMp0bQ__"